import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkCenterType } from '../work-center-type'
import { WorkCenterTypeService } from '../work-center-type.service'

@Component({
  selector: 'app-work-center-type-browser',
  templateUrl: './work-center-type-browser.component.html',
  styleUrls: ['./work-center-type-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class WorkCenterTypeBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<WorkCenterType>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(WorkCenterTypeService)
    this.data = DataContextBuilder.start<WorkCenterType>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(typeService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(wct: WorkCenterType): void {
    this.router.navigate([{ outlets: { side: ['work-centers', 'types', wct.id] } }], {
      preserveFragment: true,
    })
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['work-centers', 'types', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
